var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RequestsTableRedesigned',{attrs:{"api-url-props":'/v2/requests?in_turn=true',"title":"In Turn Requests"}})}
var staticRenderFns = []

export { render, staticRenderFns }